export default __webpack_public_path__ + "static/flexible-c08996ee090c322d01b3856d821ee369.png";